import {testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {useVehiclesActionCallback} from '../../hooks/useVehiclesActionCallback';
import {vehicleBulkOperationActionCallback} from '../../utils/vehicleBulkOperationActionCallback';

export function OSVehicles() {
  const [actionCallback] = useVehiclesActionCallback();

  return (
    <DmsDataGrid
      gridCode="vehicle-opensearch"
      data-testid={testIds.vehicles.vehicleOpenSearch()}
      // eslint-disable-next-line eslint-js/no-restricted-syntax
      key="vehicle-opensearch"
      actionCallback={actionCallback}
      bulkOperationActionCallback={vehicleBulkOperationActionCallback}
    />
  );
}
